<template>
  <v-container style="width: 100%; padding-bottom: 200px;">
    <v-layout justify-space-between>
      <h1>Availability Regions</h1>
      <v-btn @click="create" color="green" dark class="text-none">Add New Region</v-btn>
    </v-layout>
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <v-layout pa-2 column>
            <h3>Regions</h3>
            <p>
              <br />The regions on this map dictate where your customers can be picked up or dropped off from when booking using the app, third party booking tools or website
            </p>
            <p>Click a region to select it. You can then delete the region. drag to move, or modify the shape of the region.</p>
            <p>To add a new region you can click the "Add New Region" button in the top right of this page. You can then proceed to draw the shape onto the map, joining the first point to the last point</p>
          </v-layout>
        </SimpleCard>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
          <AvailabilityRegionList :availability_regions="regions" @orderChange="changeOrder($event)"/>
      </v-flex>
      <v-flex xs12 md10 xl8 py-3>
        <SimpleCard>
          <v-layout pa-2 column>
            <AreaPolygonMap ref="areaMap" :height="600"></AreaPolygonMap>
            <v-layout pt-3 >
              <v-col>
               <v-row  v-if="selectedRegion != null" >
                 <v-flex xs3>
                   <v-text-field v-model="selectedRegion.name" label="Region Name"/>
                 </v-flex>
                 <v-flex pt-2 xs3><v-btn @click="update">Update Name</v-btn>
                 </v-flex>
                 </v-row>
                <v-btn
                @click="deleteRegion"
                v-if="selectedPolygon != null"
                class="text-none"
                color="red lighten-2"
                dark
              >Delete Region</v-btn>
                 <h4
                v-if="selectedRegion != null"
              >{{selectedPolygon.regionId}}</h4>
                <AvailabilityRegionRideTypeTariffList :availabilityRegion="selectedRegion" :ride_types="selectedRegion.ride_type_tariffs" v-if="selectedRegion != null"/>
              </v-col>
            </v-layout>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import AvailabilityRegionList from "@/components/settings/general/availability/AvailabilityRegionList.vue";
import OperatingRegions from "@/components/settings/general/availability/OperatingRegions.vue";
import AreaPolygonMap from "@/components/widget/AreaPolygonMap.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import AvailabilityRegionRideTypeTariffList from "@/components/settings/pricing/AvailabilityRegionRideTypeTariffList"

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "operating_regions",
  components: {
    AvailabilityRegionList,
    OperatingRegions,
    AreaPolygonMap,
    SimpleCard,AvailabilityRegionRideTypeTariffList
  },
  data: function() {
    return {
      drawingManager: null,
      selectedColor: "#ff0000",
      inactiveColor: "#0000ff",
      fillColor: "#ababab",
      selectedPolygon: null,
      regions: [],
      selectedRegion: null,
    };
  },
  mounted: function() {
    setTimeout(this.getRegions, 300);
  },
  methods: {
     changeOrder: async function(availabilityRegionsHeavy) {

      var availabilityRegions = [];

      for (let i = 0; i < availabilityRegionsHeavy.length; i++) {
        availabilityRegions.push({id: availabilityRegionsHeavy[i].id})
      }

      if (availabilityRegions) {
        for (let i = 0; i < availabilityRegions.length; i++) {
          availabilityRegions[i].priority = i + 1;
        }

        let self = this;
        let url = `${this.$store.state.apiUrl}/availability_region/reorder`;

        axios({
          url: url,
          method: "post",
          data: {
            availability_regions: availabilityRegions
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.showSnackbar("Error changing availability region order", "success");
            } else if (response.data.error != "no_error") {
              self.showSnackbar(
                "Error changing availability region order" + response.data.error,
                "success"
              );
              console.log(response.data.error);
            } else {
              self.showSnackbar("Availability region order changed", "success");
            }
          })
          .catch(function(error) {
            console.log(error);
            //self.showSnackbar("Network error: " + error, "error");
          });
      }
    },
    update: function() {
      var url = `${this.$store.state.apiUrl}/availability_region/${this.selectedRegion.id}?name=${this.selectedRegion.name}`;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
          } else {
            throw res.data.error;
          }
        })
        .catch(function(err) {
          alert("Error " + err);
        });
    },
    getRegionJoined: async function(id) {

        var url = `${this.$store.state.apiUrl}/availability_region/get/${id}`;

        let response = await axios.get(url, {
          params: {}
        });

        this.selectedRegion = response.data.availability_region;

    

    },
    getRegions: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/availability_region/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.regions.length = 0;

        var bounds = new google.maps.LatLngBounds();

        for (var j = 0; j < response.data.length; j++) {
          console.log(j);

          var region = response.data[j];

          var coords = [];
          var polygonJSON = region.area;

          for (var i = 0; i < polygonJSON.length; i++) {
            coords.push({
              lat: polygonJSON[i][0],
              lng: polygonJSON[i][1]
            });

            bounds.extend({
              lat: polygonJSON[i][0],
              lng: polygonJSON[i][1]
            });
          }

          region.polygon = this.addPolygon(coords, region.id);

          this.addUpdateListenersToPolygon(region.polygon);

          this.regions.push(region);
        }

        if (this.regions.length != 0) {
          this.$refs.areaMap.map.fitBounds(bounds);
        }

        console.log("got availability regions");
      } catch (error) {
        this.loading = false;
        console.log("Failed to get availability regions " + error);
      }
    },
    addPolygon: function(coords, id) {
      console.log("Adding polygon");

      var polygon = new google.maps.Polygon({
        paths: coords,
        editable: true,
        draggable: true,
        strokeColor: this.inactiveColor,
        fillColor: this.fillColor,
        regionId: id,
      });

      polygon.setMap(this.$refs.areaMap.map);

      console.log("Restored polygon");

      var select = this.select;

      google.maps.event.addListener(polygon, "click", function(event) {
        console.log("Polygon clicked");
        select(polygon);
      });

      return polygon;
    },
    select: function(polygon) {
      this.clearSelected();
      this.selectedPolygon = polygon;
      this.selectedPolygon.set("strokeColor", this.selectedColor);

      this.getRegionJoined(this.selectedPolygon.regionId)
    },
    clearSelected: function() {
      for (var i = 0; i < this.regions.length; i++) {
        this.regions[i].polygon.set("strokeColor", this.inactiveColor);
      }

      this.regions.selectedPolygon = null;
    },
    create: function() {
      var addRegion = this.addRegion;

      if (this.drawingManager == null) {
        this.drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
            position: google.maps.ControlPosition.TOP_CENTER,
            drawingModes: ["polygon"]
          },
          polygonOptions: {
            editable: true,
            strokeColor: this.selectedColor
          }
        });

        var drawingManager = this.drawingManager;

        google.maps.event.addListener(
          this.drawingManager,
          "overlaycomplete",
          function(event) {
            event.overlay.set("editable", true);
            event.overlay.set("draggable", true);
            drawingManager.setMap(null);
            console.log(event.overlay);

            addRegion(event.overlay);
          }
        );
      }

      this.drawingManager.setMap(this.$refs.areaMap.map);
    },
    addRegion: async function(polygon) {
      var coords = this.coordsToServerCoordinateFormat(polygon);

      var regions = this.regions;

      var url = `${this.$store.state.apiUrl}/availability_region/create`;

      var clearSelected = this.clearSelected;

      var addUpdateListenersToPolygon = this.addUpdateListenersToPolygon;

      var select = this.select;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify({ area: JSON.stringify(coords) }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            regions.push({
              id: res.data.availability_region.id,
              area: res.data.availability_region.area,
              polygon: polygon
            });

            google.maps.event.addListener(polygon, "click", function(event) {
              console.log("Polygon clicked");
              select(polygon);
            });

            addUpdateListenersToPolygon(polygon);

            clearSelected();
          } else {
            throw res.data.error;
          }
        })
        .catch(function(err) {
          alert("Error " + err);
        });
    },
    updateRegion: async function(polygon) {
      var coords = this.coordsToServerCoordinateFormat(polygon);

      var region = this.regions.find(function(rg) {
        return rg.polygon == polygon;
      });

      var url = `${this.$store.state.apiUrl}/availability_region/${region.id}`;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify({ area: JSON.stringify(coords) }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
          } else {
            throw res.data.error;
          }
        })
        .catch(function(err) {
          alert("Error " + err);
        });
    },
    deleteRegion: async function() {
      var polygon = this.selectedPolygon;

      var region = this.regions.find(function(rg) {
        return rg.polygon == polygon;
      });

      if (region == null) {
        console.log("No region found");
        return;
      }

      var url = `${this.$store.state.apiUrl}/availability_region/${region.id}/delete`;

      var clearSelected = this.clearSelected;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            polygon.setMap(null);
            clearSelected();
          } else {
            throw res.data.error;
          }
        })
        .catch(function(err) {
          alert("Error " + err);
        });
    },
    addUpdateListenersToPolygon: function(polygon) {
      var me = this;
      var superClass = polygon;
      var isBeingDragged = false;

      var updateRegion = this.updateRegion;

      var triggerCoordinatesChanged = function() {
        console.log("Sum shit done changed");
        updateRegion(polygon);
      };

      // If the overlay is being dragged, set_at gets called repeatedly,
      // so either we can debounce that or ignore while dragging,
      // ignoring is more efficient.
      google.maps.event.addListener(superClass, "dragstart", function() {
        isBeingDragged = true;
      });

      // If the overlay is dragged
      google.maps.event.addListener(superClass, "dragend", function() {
        triggerCoordinatesChanged();
        isBeingDragged = false;
      });

      // Or vertices are added to any of the possible paths, or deleted
      var paths = superClass.getPaths();
      paths.forEach(function(path, i) {
        google.maps.event.addListener(path, "insert_at", function() {
          triggerCoordinatesChanged();
        });
        google.maps.event.addListener(path, "set_at", function() {
          if (!isBeingDragged) {
            triggerCoordinatesChanged();
          }
        });
        google.maps.event.addListener(path, "remove_at", function() {
          triggerCoordinatesChanged();
        });
      });
    },
    coordsToServerCoordinateFormat: function(polygon) {
      var serverCoordinates = [];

      for (var i = 0; i < polygon.getPath().getLength(); i++) {
        serverCoordinates.push([
          polygon
            .getPath()
            .getAt(i)
            .lat(),
          polygon
            .getPath()
            .getAt(i)
            .lng()
        ]);
      }

      serverCoordinates.push([
        polygon
          .getPath()
          .getAt(0)
          .lat(),
        polygon
          .getPath()
          .getAt(0)
          .lng()
      ]);

      return serverCoordinates;
    }
  }
};
</script>
